import { render, staticRenderFns } from "./CustomizationSettings.vue?vue&type=template&id=509356be&scoped=true"
import script from "./CustomizationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizationSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomizationSettings.vue?vue&type=style&index=0&id=509356be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509356be",
  null
  
)

export default component.exports